import { Component, Input, OnInit } from '@angular/core';
import { CustomerTag } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus, searchStringList } from '../../../../../../../utils';

@Component({
  selector: 'app-add-customer-tag-modal',
  templateUrl: './add-customer-tag-modal.component.html',
  styleUrls: ['./add-customer-tag-modal.component.css']
})
export class AddCustomerTagModalComponent implements OnInit {

  @Input() customerId: number;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public tagSearchInput = '';
  public tagName = '';
  public creatingNewTag = false;
  public tagOptions: CustomerTag[];

  public loadingTags = false;
  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public ngOnInit() {
    this.loadTags();
  }

  public toggleCreatingNewTag(creatingNewTagStatus: boolean) {
    if (this.creatingNewTag === creatingNewTagStatus) { return; }

    this.creatingNewTag = creatingNewTagStatus;
    this.tagSearchInput = '';
    this.tagName = '';
  }

  public getMatchedTags(): string[] {
    return searchStringList(
      this.tagSearchInput,
      this.tagOptions.map(tag => tag.name)
    );
  }

  public handleSave() {
    if (this.tagName.trim() === '') { return; }

    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .addCustomerTag(
        this.customerId,
        this.tagName
      )
      .then(() => {
        this.savedCallback({
          text: 'Tag \'' + this.tagName + '\' added successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to add customer tags.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public saveButtonEnabled() {
    return (
      (this.tagName.trim() !== '') &&
      !this.loadingSubmit
    );
  }

  private loadTags() {
    this.loadingTags = true;

    this.customerService.getCustomerTags(1, 1000)
      .then(response => {
        this.tagOptions = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to add customer tags.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingTags = false; });
  }

}
